import superagent from 'superagent';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import {
  loadCommentsApi,
  // getSortTypeData,
  // config,
  getCommentsPostApi,
  // getCommentsValidateApi,
  getFlagApiData,
} from './config';
import makeRequest from '../../utils/makeRequest';
import { encodeDataForFormUrlEncodedRequest } from './utils';
import { getSiteDomain } from '../../utils/common';

const reducerName = 'comments';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECEIVE_DATA = createActionName('RECEIVE_DATA');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');
export const POST_RESPONSE = createActionName('POST_RESPONSE');
export const UPDATE_VOTECOUNT = createActionName('UPDATE_VOTECOUNT');
export const UPDATE_COMMENTS = createActionName('UPDATE_COMMENTS');
export const MARK_FOLLOWING = createActionName('MARK_FOLLOWING');
export const ADD_FOLLOWEES = createActionName('ADD_FOLLOWEES');

// action creators
function commentsData(data, params, isMerge) {
  return {
    type: RECEIVE_DATA,
    payload: {
      commentsData: data,
      msid: params.msid,
      isMerge,
      isAgreed: params.commenttype === 'agree',
    },
  };
}

function postCommentActionCreator(data) {
  return {
    type: POST_RESPONSE,
    payload: {
      response: data,
    },
  };
}

function loadCommentsData(params) {
  const { endpoint } = loadCommentsApi();
  const pageParams = {
    lastdeenid: 123,
  };

  //todo
  //console.log("loadCommentsApi", params, pageParams);
  const requestParams = {
    ...loadCommentsApi().params,
    ...pageParams,
    ...params,
  };
  return makeRequest.get(
    endpoint,
    {
      params: requestParams,
    },
    'skipfeedengine',
  );
}

function postCommentApi(data) {
  const domain = getSiteDomain();
  const endpoint = domain + getCommentsPostApi().endpoint;
  const defaultParams = getCommentsPostApi().params;
  let newData = { ...defaultParams, ...data };

  newData = encodeDataForFormUrlEncodedRequest(newData);

  return makeRequest.post(endpoint, newData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
  });
}

function flagComment(params) {
  const domain = getSiteDomain();
  const endpoint = domain + getFlagApiData().endpoint;
  const defaultParams = getFlagApiData().params;
  const data = { ...defaultParams, ...params };

  return superagent
    .get(endpoint)
    .query(data)
    .set({
      Accept: 'text/html, */*; q=0.01',
    });
}

export function getCommentsData(params, callback) {
  // console.log(6789);
  // console.log(params);
  return dispatch =>
    loadCommentsData(params)
      .then(data => {
        dispatch(commentsData(data.data, params));
        if (typeof callback === 'function') {
          callback();
        }
      })
      .catch(() => {
        // console.log('getCommentsData error' + error)
        if (typeof callback === 'function') {
          callback();
        }
      });
}

export function getMoreComments(params, callback) {
  // console.log(6789);
  // console.log(params);
  return dispatch =>
    loadCommentsData(params)
      .then(data => {
        dispatch(commentsData(data.data, params, true));
        if (typeof callback === 'function') {
          callback();
        }
      })
      .catch(() => {
        // console.log('getCommentsData error' + error)
        if (typeof callback === 'function') {
          callback();
        }
      });
}

export function postComment(params, callback) {
  /*
-   * get pcode from user login,
-   * times point tp channel
-   */
  return dispatch =>
    postCommentApi(params)
      .then(data => {
        dispatch(postCommentActionCreator);
        callback(data, params);
      })
      .catch(() => {
        // console.log("error", error)
      });
}

export function onFlagComment(params, callback) {
  return () =>
    flagComment(params)
      .then(data => {
        callback(data, params);
      })
      .catch(() => {
        // console.log('onFlagComment: error');
      });
}

export function updateVoteCount(params) {
  return {
    type: UPDATE_VOTECOUNT,
    payload: {
      params,
    },
  };
}

export function updateComments(params) {
  return {
    type: UPDATE_COMMENTS,
    payload: {
      msid: params.msid,
      comments: params.comments,
    },
  };
}

// reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_DATA: {
      let comments = [];
      const commentsDataKey = `commentsData-${action.payload.msid}`;
      const commentsLoaded = action.payload.commentsData;
      if (action.payload.isMerge) {
        comments = state[commentsDataKey].concat(commentsLoaded.slice(1));
      } else {
        comments = commentsLoaded;
      }

      const returnState = {
        ...state,
        commentsData: [],
        [commentsDataKey]: comments,
      };

      if (action.payload.isAgreed) {
        returnState[`${commentsDataKey}-agreed`] = comments;
      }
      return returnState;
    }
    case POST_RESPONSE:
      return {
        ...state,
        postCommentsResponse: action.payload.response,
      };
    case UPDATE_COMMENTS:
      return {
        ...state,
        [`commentsData-${action.payload.msid}`]: action.payload.comments,
      };
    case UPDATE_VOTECOUNT: {
      const commentsObj = [
        ...state[`commentsData-${action.payload.params.msid}`],
      ];
      const keyName =
        action.payload.params.voteType === 'AGREED' ? 'AC_A_C' : 'AC_D_C';
      if (commentsObj && commentsObj.length > 0) {
        for (let i = 0; i < commentsObj.length; i += 1) {
          if (commentsObj[i]._id === action.payload.params.commentId) {
            commentsObj[i][keyName] = action.payload.params.voteCount;
            break;
          }
        }
      }
      return {
        ...state,
        [`commentsData-${action.payload.msid}`]: commentsObj,
      };
    }
    case MARK_FOLLOWING: {
      const followees =
        state.followees && state.followees.length > 0
          ? [...state.followees]
          : [];
      followees.push(action.payload.response);
      return {
        ...state,
        followees,
      };
    }
    case ADD_FOLLOWEES: {
      return {
        ...state,
        followees: [...action.payload.response],
        hasFolloweesData: action.payload.hasFolloweesData,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
